import { stateSchema } from '@nesso/practice-contracts/practice-member.models';

export const stateOptions = stateSchema.options.map((value) => ({
    value,
    label: value,
}));
